import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Settings from '@/classes/settings.js'
import MyUtils from '@/classes/my_utils.js'
import NetworkUtils from '@/classes/network_utils.js'
import OffersHelper from '@/classes/offers_helper.js'
import Form from '@/classes/form.js'

import VueMoment from '@/plugins/moment-plugin.js'
import VueSanitize from '@/plugins/sanitize-html-plugin.js'

Vue.use(VueMoment)
Vue.use(VueSanitize)

Vue.prototype.$settings = new Settings()
Vue.prototype.$network_utils = new NetworkUtils()
Vue.prototype.$offers_helper = new OffersHelper()
Vue.prototype.$utils = MyUtils
Vue.prototype.$form = Form

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
